export default "__VITE_ASSET__Bufu_nD4__"